import { makeAutoObservable, action } from 'mobx';
import {
  getCompanyProfile,
  createCompanyProfile,
  updateCompanyProfile
}
from '../api/SlmService';
import notificationStore from './NotificationStore';

class CompanyProfileStore {

  companyProfile = {};

  existingProfile = false;

  isLoading = false;

  submitErrorNotification = false;

  submitSuccessNotification = false;

  notificationStore = {};

  constructor(newNotificationStore) {
    this.notificationStore = newNotificationStore;
    makeAutoObservable(this);
  }

  setCompanyProfile = (value) => {
    this.companyProfile = { ...this.companyProfile, ...value };
  };

  setExistingProfile = (value) => {
    this.existingProfile = value;
  };

  setIsLoading = (value) => {
    this.isLoading = value;
  };

  setSubmitErrorNotification = (value) => {
    this.submitErrorNotification = value;
  };

  setSubmitSuccessNotification = (value) => {
    this.submitSuccessNotification = value;
  };

  showSubmitErrorNotification = () => {
    this.setSubmitErrorNotification(true);

    setTimeout(() => {
      this.setSubmitErrorNotification(false);
    }, 5000);
  };

  showSubmitSuccessNotification = () => {
    this.setSubmitSuccessNotification(true);

    setTimeout(() => {
      this.setSubmitSuccessNotification(false);
    }, 5000);
  };

  getCompanyProfile = () => {
    this.setIsLoading(true);
    getCompanyProfile().then(
      action('success', (res) => {
        this.setCompanyProfile(res?.data);
        this.setExistingProfile(!!res?.data?.companyProfileId);
      }),
      action('error', () => {
        this.notificationStore.setError('Failed to retrieve company profile');
      })
    )
      .finally(() => {
        this.setIsLoading(false);
      });
  };

  submitCompanyProfile = () => {
    if (this.existingProfile) {
      updateCompanyProfile(
        this.companyProfile.companyProfileId,
        this.companyProfile.url,
        this.companyProfile.description
      ).then(
        action('success', () => {
          this.showSubmitSuccessNotification();
        }),
        action('error', () => {
          this.notificationStore.setError('Failed to update company profile. Please reload the page and try again. We apologize for the inconvenience');
        })
      );
    } else {
      createCompanyProfile(this.companyProfile.url, this.companyProfile.description).then(
        action('success', () => {
          this.showSubmitSuccessNotification();
        }),
        action('error', () => {
          this.notificationStore.setError('Failed to create company profile. Please reload the page and try again. We apologize for the inconvenience');
        })
      );
    }
  };

}

export default new CompanyProfileStore(notificationStore);
